<template>
  <div class="card-container custom-scrollbar">
    <div class="card-options">
      <div class="callback-options">
        <v-icon color="var(--v-success-base)">mdi-circle</v-icon>
        <div>Callbacks Enabled</div>
        <v-icon color="var(--v-error-base)">mdi-stop</v-icon>
        <v-icon>mdi-cog</v-icon>
      </div>
      <div class="callback-search-toolbar">
        <ecs-search-input :placeholder="'Search Callbacks'" @search-input-changed="handleSearch" />
        <v-icon>mdi-view-column</v-icon>
      </div>
    </div>
    <div class="callback-history-table">
      <v-data-table
        dense
        class="surface lighten-1 custom-scrollbar"
        :headers="headers"
        :items="items"
        :search="searchText"
        :items-per-page="5"
        :items-per-page-text="'Rows Per Page'"
      >
        <template slot="items" slot-scope="props">
          <tr class="test">
            <td v-for="(row, index) in rows" :key="index">
              <span> {{ props.item[row.value] }} </span>
            </td>
          </tr>
        </template>

        <v-alert slot="no-results" color="error" icon="warning">
          {{ 'No results found' }}
        </v-alert>

        <template slot="pageText" slot-scope="props">
          {{ props.pageStart }} - {{ props.pageStop }} }}
          {{ props.itemsLength }}
        </template>
      </v-data-table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EcsBusinessProcessMonitoringCallbacksCard',

  props: {
    businessProcessId: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      searchText: ''
    };
  },

  computed: {
    headers() {
      return [
        { text: 'Destination', value: 'destination' },
        { text: 'Created', value: 'created' },
        { text: 'Queued', value: 'queued' },
        { text: 'Attempts', value: 'attemps' },
        { text: 'Assignment', value: 'assignment' },
        { text: 'Status', value: 'status' },
        { text: 'Remarks', value: 'remarks' },
        { text: 'Dest. Time', value: 'destinationTime' }
      ];
    },

    items() {
      const commonCreated = '10/25 3:22pm';
      const commonAssignment = 'David Walters';
      const commonRemarks = 'Rude Caller';
      const commonQueue = 'Today 7:30am';
      const commonDestinationTime = '10/29 7:30a (-0500)';
      return [
        {
          destination: 14843400177,
          created: commonCreated,
          queued: commonQueue,
          attempts: 'None',
          assignment: commonAssignment,
          status: 'Pending',
          remarks: commonRemarks,
          destinationTime: commonDestinationTime
        },
        {
          destination: 14843400177,
          created: commonCreated,
          queued: commonQueue,
          attempts: 'None',
          assignment: commonAssignment,
          status: 'Pending',
          remarks: commonRemarks,
          destinationTime: commonDestinationTime
        },
        {
          destination: 14843400177,
          created: commonCreated,
          queued: commonQueue,
          attempts: 'None',
          assignment: commonAssignment,
          status: 'Pending',
          remarks: commonRemarks,
          destinationTime: commonDestinationTime
        },
        {
          destination: 14843400177,
          created: commonCreated,
          queued: commonQueue,
          attempts: 'None',
          assignment: commonAssignment,
          status: 'Pending',
          remarks: commonRemarks,
          destinationTime: commonDestinationTime
        }
      ];
    }
  },

  methods: {
    handleSearch(searchText) {
      this.searchText = searchText;
    }
  }
};
</script>

<style scoped>
.card-container {
  display: grid;
  grid-template-rows: 24px auto;
  height: 100%;
}

.card-options {
  width: 100%;
  display: grid;
  grid-template-columns: 240px auto;
  font-size: 12px;
  align-items: center;
}

.card-options >>> .v-icon {
  font-size: 18px;
}

.callback-options {
  justify-self: start;
  width: 100%;
  display: grid;
  grid-template-columns: 24px auto 24px 24px;
  column-gap: 4px;
  height: 100%;
  align-items: center;
}

.callback-search-toolbar {
  justify-self: end;
  align-content: center;
  width: 100%;
  display: grid;
  grid-template-columns: auto 24px;
  column-gap: 4px;
  height: 100%;
}

.callback-search-toolbar >>> .main-container {
  width: 100%;
}

.callback-search-toolbar >>> .inner-container {
  border-color: rgba(255, 255, 255, 0.5);
}

.callback-search-toolbar >>> .search-input,
.callback-search-toolbar >>> .search-input-icon {
  font-size: 12px;
  line-height: 12px;
}

.callback-history-table >>> .v-data-table .v-data-table__wrapper > table > thead > tr > th,
.callback-history-table >>> .v-data-table .v-data-table__wrapper > table > tbody > tr > td {
  padding: 0 4px !important;
  font-size: 10px;
}

.callback-history-table >>> .v-data-table .v-data-table-header th.sortable .v-data-table-header__icon {
  font-size: 10px !important;
  margin-left: 2px;
}
</style>
